import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Apr 01 2019
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { CodebookLookupSequence, SelloutRelease } from '@logio/common-be-fe';
import { computed, runInAction } from 'mobx';
import { arrayToMap } from '../../utils';
import { StoreName } from '../StoreName';
import { AbstractReleaseStore } from './AbstractReleaseStore';
/**
 * Release store
 */

export var ReleaseSelloutStore =
/*#__PURE__*/
function (_AbstractReleaseStore) {
  _inherits(ReleaseSelloutStore, _AbstractReleaseStore);

  function ReleaseSelloutStore() {
    var _this;

    _classCallCheck(this, ReleaseSelloutStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseSelloutStore).apply(this, arguments));
    /** @inheritDoc */

    _this.name = StoreName.SelloutRelease;
    return _this;
  }
  /** @inheritDoc */


  _createClass(ReleaseSelloutStore, [{
    key: "getOne",
    value: function getOne(releaseId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var release;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.t0 = SelloutRelease;
                _context.next = 4;
                return this.releaseLayer.findOne(releaseId);

              case 4:
                _context.t1 = _context.sent;
                release = _context.t0.requireSelloutRelease.call(_context.t0, _context.t1);
                runInAction(function () {
                  return _this2.release = release;
                });
                return _context.abrupt("return", release);

              case 10:
                _context.prev = 10;
                _context.t2 = _context["catch"](0);
                return _context.abrupt("return", this.handleCatchError(_context.t2, 'getOne'));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "create",
    value: function create(newRelease) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var release;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.releaseLayer.createSellout(newRelease);

              case 3:
                release = _context2.sent;
                runInAction(function () {
                  return _this3.release = release;
                });
                return _context2.abrupt("return", release);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", this.handleCatchError(_context2.t0, 'create'));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "getPriceListSettings",
    value: function getPriceListSettings() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var priceListSettings;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.releaseLayer.getPriceListSettings();

              case 3:
                priceListSettings = _context3.sent;
                return _context3.abrupt("return", priceListSettings);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", this.handleCatchError(_context3.t0, 'price-list-settings'));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "open",
    value: function open(id) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;

        var release;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.t0 = SelloutRelease;
                _context4.next = 4;
                return this.releaseLayer.open(id);

              case 4:
                _context4.t1 = _context4.sent;
                release = _context4.t0.requireSelloutRelease.call(_context4.t0, _context4.t1);
                runInAction(function () {
                  return _this4.release = release;
                });
                return _context4.abrupt("return", release);

              case 10:
                _context4.prev = 10;
                _context4.t2 = _context4["catch"](0);
                return _context4.abrupt("return", this.handleCatchError(_context4.t2, 'open'));

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 10]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "proceedPriceSimulation",
    value: function proceedPriceSimulation(id, selloutRelease) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this5 = this;

        var release;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.releaseLayer.proceedPriceSimulation(id, selloutRelease);

              case 3:
                release = _context5.sent;
                runInAction(function () {
                  return _this5.release = release;
                });
                return _context5.abrupt("return", release);

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", this.handleCatchError(_context5.t0, 'proceed-price-simulation'));

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 8]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "cancellPriceSimulation",
    value: function cancellPriceSimulation(id) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _this6 = this;

        var release;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.releaseLayer.cancellPriceSimulation(id);

              case 3:
                release = _context6.sent;
                runInAction(function () {
                  return _this6.release = release;
                });
                return _context6.abrupt("return", release);

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", this.handleCatchError(_context6.t0, 'cancell-price-simulation'));

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 8]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "update",
    value: function update(newRelease) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var _this7 = this;

        var release;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return this.releaseLayer.updateSellout(newRelease);

              case 3:
                release = _context7.sent;
                runInAction(function () {
                  return _this7.release = release;
                });
                return _context7.abrupt("return", release);

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", this.handleCatchError(_context7.t0, 'update'));

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 8]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "setReleaseFavorability",
    value: function setReleaseFavorability(releaseId, state) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var _this8 = this;

        var release;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.t0 = SelloutRelease;
                _context8.next = 4;
                return this.releaseLayer.setReleaseFavorability(releaseId, state);

              case 4:
                _context8.t1 = _context8.sent;
                release = _context8.t0.requireSelloutRelease.call(_context8.t0, _context8.t1);
                runInAction(function () {
                  return _this8.release = release;
                });
                return _context8.abrupt("return", release);

              case 10:
                _context8.prev = 10;
                _context8.t2 = _context8["catch"](0);
                return _context8.abrupt("return", this.handleCatchError(_context8.t2, 'setReleaseFavorability'));

              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 10]]);
      }));
    }
    /**
     * Function fetches all internal sites as codebook map
     * @returns map of internal sites as code books
     */

  }, {
    key: "getSitesAsCodebooks",
    value: function getSitesAsCodebooks() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var lookup;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return this.codeBookItemLayer.loadLookup(CodebookLookupSequence.InternalSites);

              case 3:
                lookup = _context9.sent;
                return _context9.abrupt("return", arrayToMap(lookup.codeBooks));

              case 7:
                _context9.prev = 7;
                _context9.t0 = _context9["catch"](0);
                return _context9.abrupt("return", this.handleCatchError(_context9.t0, 'getSitesAsCodebooks'));

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 7]]);
      }));
    }
    /** TODO: docs  */

  }, {
    key: "getTotal",
    value: function getTotal(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var totalDTOs;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return this.releaseLayer.findSelloutTotal(releaseId, filter);

              case 3:
                totalDTOs = _context10.sent;
                return _context10.abrupt("return", arrayToMap(totalDTOs, 'categoryId'));

              case 7:
                _context10.prev = 7;
                _context10.t0 = _context10["catch"](0);
                return _context10.abrupt("return", this.handleCatchError(_context10.t0, 'getTotal'));

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 7]]);
      }));
    }
    /** TODO: docs  */

  }, {
    key: "getTotalAsImpact",
    value: function getTotalAsImpact(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        var totalDTOs, impactMap;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return this.releaseLayer.findSelloutTotal(releaseId, filter);

              case 3:
                totalDTOs = _context11.sent;
                impactMap = new Map();
                totalDTOs.forEach(function (total) {
                  return impactMap.set(total.categoryId, total.impact);
                });
                return _context11.abrupt("return", impactMap);

              case 9:
                _context11.prev = 9;
                _context11.t0 = _context11["catch"](0);
                return _context11.abrupt("return", this.handleCatchError(_context11.t0, 'getTotalAsImpact'));

              case 12:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 9]]);
      }));
    }
    /** TODO: docs  */

  }, {
    key: "getTotalsForDetailCategoryComponent",
    value: function getTotalsForDetailCategoryComponent(releaseId, categoryId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var totalDTOs;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return this.releaseLayer.findSelloutCategoryTotal(releaseId, categoryId);

              case 3:
                totalDTOs = _context12.sent;
                return _context12.abrupt("return", arrayToMap(totalDTOs, 'categoryId'));

              case 7:
                _context12.prev = 7;
                _context12.t0 = _context12["catch"](0);
                return _context12.abrupt("return", this.handleCatchError(_context12.t0, 'getTotalsForDetailCategoryComponent'));

              case 10:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 7]]);
      }));
    }
    /** TODO: docs  */

  }, {
    key: "getSubTotalForDetailCategoryComponent",
    value: function getSubTotalForDetailCategoryComponent(releaseId, categoryId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return this.releaseLayer.findSelloutCategorySubTotal(releaseId, categoryId, filter);

              case 3:
                return _context13.abrupt("return", _context13.sent);

              case 6:
                _context13.prev = 6;
                _context13.t0 = _context13["catch"](0);
                return _context13.abrupt("return", this.handleCatchError(_context13.t0, 'getSubTotalForDetailCategoryComponent'));

              case 9:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 6]]);
      }));
    }
  }, {
    key: "getPreviousSubTotalForDetailCategoryComponent",
    value: function getPreviousSubTotalForDetailCategoryComponent(releaseId, categoryId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                _context14.next = 3;
                return this.releaseLayer.findSelloutCategoryPreviousSubTotal(releaseId, categoryId, filter);

              case 3:
                return _context14.abrupt("return", _context14.sent);

              case 6:
                _context14.prev = 6;
                _context14.t0 = _context14["catch"](0);
                return _context14.abrupt("return", this.handleCatchError(_context14.t0, 'getPreviousSubTotalForDetailCategoryComponent'));

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 6]]);
      }));
    }
  }, {
    key: "getAllSubTotalForDetailCategoryComponent",
    value: function getAllSubTotalForDetailCategoryComponent(releaseId, categoryId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        var all;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return this.releaseLayer.findSelloutCategoryAllSubTotal(releaseId, categoryId, filter);

              case 3:
                all = _context15.sent;
                return _context15.abrupt("return", [all.get(all.size - 1), all.slice(0, -1)]);

              case 7:
                _context15.prev = 7;
                _context15.t0 = _context15["catch"](0);
                return _context15.abrupt("return", this.handleCatchError(_context15.t0, 'getAllSubTotalForDetailCategoryComponent'));

              case 10:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 7]]);
      }));
    }
    /** TODO: docs  */

  }, {
    key: "getCategoryTotals",
    value: function getCategoryTotals(releaseId, categoryId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                _context16.next = 3;
                return this.releaseLayer.findSelloutCategoryItems(releaseId, categoryId, filter);

              case 3:
                return _context16.abrupt("return", _context16.sent);

              case 6:
                _context16.prev = 6;
                _context16.t0 = _context16["catch"](0);
                return _context16.abrupt("return", this.handleCatchError(_context16.t0, 'getCategoryTotals'));

              case 9:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[0, 6]]);
      }));
    }
    /**
     * TODO: docs
     * @param releaseId
     * @param filter
     */

  }, {
    key: "getProductsRealImpacts",
    value: function getProductsRealImpacts(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                _context17.next = 3;
                return this.releaseLayer.findSelloutCategoryItemsRealImpact(releaseId, filter);

              case 3:
                return _context17.abrupt("return", _context17.sent);

              case 6:
                _context17.prev = 6;
                _context17.t0 = _context17["catch"](0);
                return _context17.abrupt("return", this.handleCatchError(_context17.t0, 'getProductsRealImpacts'));

              case 9:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[0, 6]]);
      }));
    }
    /** TODO: docs  */

  }, {
    key: "getExportedCategoryTotals",
    value: function getExportedCategoryTotals(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18() {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                _context18.next = 3;
                return this.releaseLayer.findExportedSelloutCategoryTotals(releaseId, filter);

              case 3:
                return _context18.abrupt("return", _context18.sent);

              case 6:
                _context18.prev = 6;
                _context18.t0 = _context18["catch"](0);
                return _context18.abrupt("return", this.handleCatchError(_context18.t0, 'getExportedCategoryTotals'));

              case 9:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[0, 6]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "getItems",
    value: function getItems(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19() {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                _context19.next = 3;
                return this.releaseLayer.findSelloutItems(releaseId, filter);

              case 3:
                return _context19.abrupt("return", _context19.sent);

              case 6:
                _context19.prev = 6;
                _context19.t0 = _context19["catch"](0);
                return _context19.abrupt("return", this.handleCatchError(_context19.t0, 'getItems'));

              case 9:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[0, 6]]);
      }));
    }
    /**
     * Function updates SelloutReleaseItem as bulk operation(could be used for dotted updates)
     * @param updatedItemRequest
     * @returns updated SelloutReleaseItem
     */

  }, {
    key: "updateItems",
    value: function updateItems(updatedItemRequest) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20() {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                _context20.next = 3;
                return this.releaseLayer.updateSelloutItems(updatedItemRequest);

              case 3:
                return _context20.abrupt("return", _context20.sent);

              case 6:
                _context20.prev = 6;
                _context20.t0 = _context20["catch"](0);
                return _context20.abrupt("return", this.handleCatchError(_context20.t0, 'updateItems'));

              case 9:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this, [[0, 6]]);
      }));
    }
    /** @inheritDoc */

  }, {
    key: "getPromos",
    value: function getPromos(id) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21() {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                _context21.next = 3;
                return this.releaseLayer.findSelloutPromos(id);

              case 3:
                return _context21.abrupt("return", _context21.sent);

              case 6:
                _context21.prev = 6;
                _context21.t0 = _context21["catch"](0);
                return _context21.abrupt("return", this.handleCatchError(_context21.t0, 'getPromos'));

              case 9:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this, [[0, 6]]);
      }));
    }
    /**
     * Allows to reopen sellout release
     */

  }, {
    key: "reopen",
    value: function reopen(release) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee22() {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;
                _context22.next = 3;
                return this.releaseLayer.selloutReopen(release);

              case 3:
                return _context22.abrupt("return", _context22.sent);

              case 6:
                _context22.prev = 6;
                _context22.t0 = _context22["catch"](0);
                return _context22.abrupt("return", this.handleCatchError(_context22.t0, 'reopen'));

              case 9:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this, [[0, 6]]);
      }));
    }
    /**
     * Endpoint for updating targetMargin & targetProfit
     * @param updates
     */

  }, {
    key: "updateTargets",
    value: function updateTargets(targets) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23() {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.prev = 0;
                _context23.next = 3;
                return this.releaseLayer.selloutUpdateTargets(targets);

              case 3:
                return _context23.abrupt("return", _context23.sent);

              case 6:
                _context23.prev = 6;
                _context23.t0 = _context23["catch"](0);
                return _context23.abrupt("return", this.handleCatchError(_context23.t0, 'updateTargets'));

              case 9:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this, [[0, 6]]);
      }));
    }
    /** Endpoint returns Array of priceListTypeIds in which user could not edit end Date */

  }, {
    key: "getPLTsWithFixedEndDate",
    value: function getPLTsWithFixedEndDate() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee24() {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.prev = 0;
                _context24.next = 3;
                return this.releaseLayer.findPLTsWithFixedEndDate();

              case 3:
                return _context24.abrupt("return", _context24.sent);

              case 6:
                _context24.prev = 6;
                _context24.t0 = _context24["catch"](0);
                return _context24.abrupt("return", this.handleCatchError(_context24.t0, 'getPLTsWithFixedEndDate'));

              case 9:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this, [[0, 6]]);
      }));
    }
  }, {
    key: "updateItemFilter",
    value: function updateItemFilter(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee25() {
        var _this9 = this;

        var release;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.prev = 0;
                _context25.next = 3;
                return this.releaseLayer.updateItemFilter(releaseId, filter);

              case 3:
                release = _context25.sent;
                runInAction(function () {
                  return _this9.release = release;
                });
                return _context25.abrupt("return", release);

              case 8:
                _context25.prev = 8;
                _context25.t0 = _context25["catch"](0);
                return _context25.abrupt("return", this.handleCatchError(_context25.t0, 'updateItemFilter'));

              case 11:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this, [[0, 8]]);
      }));
    }
    /********************************************************************** Price Impact Report **************************************************************************/

    /** @inheritDoc */

  }, {
    key: "getTotalWithImpact",
    value: function getTotalWithImpact(id, params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee26() {
        var totalDTOs;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.prev = 0;
                _context26.next = 3;
                return this.releaseLayer.findSelloutTotalWithImpact(id, params);

              case 3:
                totalDTOs = _context26.sent;
                return _context26.abrupt("return", arrayToMap(totalDTOs, 'categoryId'));

              case 7:
                _context26.prev = 7;
                _context26.t0 = _context26["catch"](0);
                return _context26.abrupt("return", this.handleCatchError(_context26.t0, 'getTotal'));

              case 10:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this, [[0, 7]]);
      }));
    }
    /** @inheritDoc  */

  }, {
    key: "getItemsWithImpact",
    value: function getItemsWithImpact(id, params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27() {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.prev = 0;
                _context27.next = 3;
                return this.releaseLayer.findSelloutItemsWithImpact(id, params);

              case 3:
                return _context27.abrupt("return", _context27.sent);

              case 6:
                _context27.prev = 6;
                _context27.t0 = _context27["catch"](0);
                return _context27.abrupt("return", this.handleCatchError(_context27.t0, 'getTotal'));

              case 9:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this, [[0, 6]]);
      }));
    }
  }, {
    key: "reopenCount",
    get: function get() {
      return this.release.reopenSnapshots.size;
    }
  }]);

  return ReleaseSelloutStore;
}(AbstractReleaseStore);

__decorate([computed, __metadata("design:type", Object), __metadata("design:paramtypes", [])], ReleaseSelloutStore.prototype, "reopenCount", null);